import { match, Match } from 'path-to-regexp';

/**
 * Assert whether path matches route
 */
export const isMatch = (route: string, path: string): Match<object> => match(route)(path);
